import Wizard from "../../Wizard";
import { useContext } from "react";
import constants from "../../../constants";
import ContentEntry from "../ContentEntry/ContentEntry";
import AlertContext from "../../../context/AlertContext";
import { LibraryContext } from "../../../context/LibraryContext";
import McqQuestionEntry from "../QuestionEntry/McqQuestionEntry/McqQuestionEntry";
import GetQuestionDetailHooks from "../../../Hooks/Question/GetQuestionDetailHooks";
import CodingQuestionEntry from "../QuestionEntry/CodingQuestionEntry/CodingQuestionEntry";
import DescriptiveQuestionEntry from "../QuestionEntry/DescriptiveQuestionEntry/DescriptiveQuestionEntry";
import { useParams } from "react-router-dom";
import CodingSnippetEntry from "./CodingSnippetEntry/CodingSnippetEntry";

export default function QuestionEntry(Props) {
  const Alert = useContext(AlertContext);
  const LibraryCxt = useContext(LibraryContext);
  const { type } = useParams();

  GetQuestionDetailHooks();

  return +type === constants.libTypeIds.SQL ? (
    <Wizard />
  ) : +type === constants.libTypeIds.CODING_CHALLENGE ? (
    <CodingQuestionEntry {...Props} />
  ) : +type === constants.libTypeIds.MCQ ? (
    <McqQuestionEntry {...Props} />
  ) : +type === constants.libTypeIds.DESCRIPTIVE ? (
    <DescriptiveQuestionEntry {...Props} />
  ) : +type === constants.libTypeIds.CODING_SNIPPET ? (
    <CodingSnippetEntry {...Props} />
  ) : (
    +type === constants.libTypeIds.CONTENT && <ContentEntry {...Props} />
  );
}
